import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import App from "./App";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./styles/css/style.css";
import "./colors/blue.css";
import "@fortawesome/fontawesome-free/css/all.css"
import UIStore from "./common/UIStore";

document.addEventListener("DOMContentLoaded", e => {
    setUI();
});
window.addEventListener("resize", e => {
    setUI();
});

let setUI = () => {
    const width = (window.innerWidth > 0) ? window.innerWidth : 0;
    UIStore.onWindowResize(width);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

ReactDOM.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
    </BrowserRouter>,
    document.getElementById("main-wrapper") as HTMLElement
);